/* eslint-disable no-console */
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import './index.css';
import TokenManager from '@zeeve-platform/login-utility';
import InAppNotificationsManager from '@zeeve-platform/in-app-notifications-frontend';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import { globalConfig, globalConfigUrl } from './config/config';
import Urls from './utils/util';
import App from './App';
import appSubPath from './utils/helper';
import apiBackendInstance from './utils/axios';
import '@zeeve-platform/in-app-notifications-frontend/dist/esm/css/styles.css';

axios
  .get(appSubPath('/') + globalConfigUrl)
  .then((response) => {
    globalConfig.config = response.data;
  })
  .then(() => {
    if (Urls.getBackendUrl() === undefined || Urls.getBackendUrl() === null) {
      throw new Error('Backend URL not found in config');
    }
  }).then(() => TokenManager.createInstance(
    Urls.getAuthUrl(),
    apiBackendInstance,
  ))
  .then(() => new Promise((resolve) => {
    const token = TokenManager.getInstance().getAccessToken();
    InAppNotificationsManager.createInstance(Urls.getInappNotificationsUrl(token), {
      InaApp: {},
    });
    TokenManager.getInstance().updateCallbacks({
      accessTokenRotationCallbacks: {
        onAccessTokenUpdate: (access_token) => {
          // update notifications manager ws address with newer token whenever a token is rotated
          InAppNotificationsManager.getInstance().updateWsAddress(Urls.getInappNotificationsUrl(access_token));
        },
      },
    });
    resolve('ok');
  }))

  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <ToastContainer />
          <App />
      </React.StrictMode>,
      document.getElementById('root'),
    );
  })
  .catch((error) => {
    console.log('config file missing -', error);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
